import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Authentication } from '../../providers/authentication';
import { ValidationService } from '../../services/validation';

@Component({
  selector: 'signin-modal',
  styleUrls: ['./signin.scss'],
  templateUrl: './signin.pug'
})

export class SigninComponent {
  public signInForm: FormGroup;
  public submitted: boolean;
  public signInErrors: boolean;
  passwordShown: boolean = false;

  constructor(public authService: Authentication,
              public toastr: ToastsManager,
              private router: Router,
              public activeModal: NgbActiveModal,
              private _fb: FormBuilder) {}

  ngOnInit(){
    this.signInForm = this._fb.group(this.formInit());

    this.authService.userUpdated.subscribe((user: Object) => {
      this.activeModal.close(user); }
    )
  }

  formInit() {
    const user = {
      email: ['', Validators.compose([Validators.required, ValidationService.emailValidator])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    };
    return user;
  }

  submitForm() {
    this.submitted = true;
    if(this.signInForm.valid) {
      this.signIn();
    }
  }

  signIn() {
    this.authService.signIn({client: this.signInForm.value}).subscribe((data) => {
      this.authService.setUser(data['user']);
    }, (err) => {
      this.signInErrors = true;
      this.signInForm.markAsPristine();
      this.toastr.info('Sign in failed!');
    });
  }

  openSignUp() {
    this.activeModal.close();
    this.router.navigate(['./signup']);
  }

  openForgotPassword() {
    this.activeModal.close('forgot password');
  }

  showPassword(input: any): any {
    input.type = input.type === 'password' ?  'text' : 'password';
    this.passwordShown = !this.passwordShown;
  }
}



// WEBPACK FOOTER //
// ./src/components/signin/signin.ts